import { call, put, select, takeLatest, takeLeading } from "redux-saga/effects";
import { API_URL } from "utils/constants";
import { getPaginationMeta } from "utils/helpers/pagination";
import { request } from "utils/request";

import { FloorTypeForm, FloorTypeListResponse } from "../types";
import { selectForm, selectPage, selectPerPage } from "./selector";
import { actions } from "./slice";

let isFetchingList = false;

export function* handleGetList() {
  if (isFetchingList) return;
  isFetchingList = true;

  try {
    const page: number = yield select(selectPage);
    const perPage: number = yield select(selectPerPage);

    const response: FloorTypeListResponse = yield call(
      request,
      `${API_URL}/floor-type/list?page=${page}&perPage=${perPage}`,
      { method: "GET" },
    );

    const rawData = response?.data || [];
    const meta = getPaginationMeta(page, perPage, rawData, response?.meta);
    const data = rawData.filter((item) =>
      Boolean(String(item?.floorTypeName ?? "").trim()),
    );
    const payload = { data, meta };

    if (page === 1) {
      yield put(actions.getListSuccess(payload));
    } else {
      yield put(actions.getNextPageItemsSuccess(payload));
    }
  } catch (error) {
    const message = (error as Error).message;
    const page: number = yield select(selectPage);

    if (page === 1) {
      yield put(actions.getListError(message));
    } else {
      yield put(actions.getNextPageItemsError(message));
    }
  } finally {
    isFetchingList = false;
  }
}

export function* handleAdd() {
  const form: FloorTypeForm = yield select(selectForm);

  try {
    yield call(request, `${API_URL}/floor-type`, {
      method: "POST",
      body: JSON.stringify({
        floorTypeName: form.floorTypeName.trim(),
      }),
    });

    yield put(actions.addSuccess());
    yield put(actions.getList());
  } catch (error) {
    yield put(actions.addError((error as Error).message));
  }
}

export function* floorTypeSaga() {
  yield takeLeading(actions.getList.type, handleGetList);
  yield takeLeading(actions.getNextPageItems.type, handleGetList);
  yield takeLatest(actions.add.type, handleAdd);
}

export default floorTypeSaga;
